import { useEffect, useRef, useCallback } from 'react';

const INACTIVITY_MS = 15 * 60 * 1000;  // 15 minutes → logout
const WARNING_MS   = 13 * 60 * 1000;  // 13 minutes → show warning (2 min before)

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

/**
 * Watches for user inactivity and calls onWarn / onLogout at the appropriate times.
 * Only active when `enabled` is true (i.e. user is authenticated).
 */
export default function useInactivityLogout({ enabled, onWarn, onLogout }) {
  const warnTimer   = useRef(null);
  const logoutTimer = useRef(null);

  const clearTimers = useCallback(() => {
    clearTimeout(warnTimer.current);
    clearTimeout(logoutTimer.current);
  }, []);

  const resetTimers = useCallback(() => {
    clearTimers();
    warnTimer.current   = setTimeout(onWarn,   WARNING_MS);
    logoutTimer.current = setTimeout(onLogout, INACTIVITY_MS);
  }, [clearTimers, onWarn, onLogout]);

  useEffect(() => {
    if (!enabled) return;

    resetTimers();

    ACTIVITY_EVENTS.forEach((e) => window.addEventListener(e, resetTimers, { passive: true }));
    return () => {
      clearTimers();
      ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, resetTimers));
    };
  }, [enabled, resetTimers, clearTimers]);
}
